import templates from 'framework/router/page-templates';

/**
 * Lazily and dynamically import the styleguide page
 * @param {string} name - The component name
 * @return {object} An object containing the styleguide page component
 */
export function importStyleguidePage(name) {
    const result = {};

    if (window.styleguide) {
        result[name] = templates.styleguide;
    }

    return result;
}
